<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalCreateModalMenuItem"
      id="show-modal-select-item"
    ></material-button>
    <material-button
      class="d-none"
      data-bs-dismiss="modal"
      data-bs-target="#modalCreateModalMenuItem"
      id="hide-modal-select-item"
    ></material-button>
    <div
      class="modal fade"
      id="modalCreateModalMenuItem"
      tabindex="-1"
      aria-hidden="true"
      ref="createModalMenuItem"
      style="z-index: 9999"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" style="width: unset">
          <div class="modal-body" style="overflow-y: unset">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="modal-title">
                Choose an option
              </h5>
              <i
                style="cursor: pointer"
                class="material-icons btn-close-modal justify-content-end"
                data-bs-dismiss="modal"
                aria-label="Close"
                >clear</i
              >
            </div>
            <div class="row mx-auto justify-content-center" style="width: max-content;">
              <div class="content col-lg-6 col-12" @click="openModalCreateItem()">
                <div>
                  <h5>Create New Item</h5>
                  <i class="material-icons css-icon-menubook">edit</i>
                </div>
              </div>
              <!-- <div class="content">
                <div
                  class="mt-content"
                  @click="openModalCreateCombo()"
                >
                  <h5>Create New Combo</h5>
                  <i class="material-icons css-icon-menubook">edit</i>
                </div>
              </div> -->
              <div class="content col-lg-6 col-12" @click="openSelectExistingItem()">
                <div>
                  <h5>Select Existing Item</h5>
                  <i class="material-icons css-icon">credit_score</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalAddExistingItem
    :categoryId="categoryId"
    :groupId="groupId"
    :subGroupId="subGroupId"
    :keyReload="keyReloadModalAddExistingItem"
    @reload-list-category="reloadListCategory"
  ></ModalAddExistingItem>
</template>

<script>
import $ from "jquery";
import MaterialButton from "@/components/MaterialButton.vue";
import ModalAddExistingItem from "@/components/ModalAddExistingItem.vue";

export default {
  name: "create-menu-item",
  components: {
    MaterialButton,
    ModalAddExistingItem,
  },
  props: {
    type: {
      type: Number,
      required: true,
    },
    setId: {
      type: Number,
      required: true,
    },
    categoryId: {
      type: Number,
      required: true,
    },
    groupId: {
      type: Number,
      default: 0,
    },
    subGroupId: {
      type: Number,
      default: 0,
    },
    keyReload: {
      type: String,
      required: true,
    },
    isModifiderOptionGroup: {
      type: Boolean,
      required: false,
    },
    modifier_option_group_id: {
      type: Number,
      required: false,
    },
    date_time_now: {
      type: Object,
      required: false,
    },
    attachedToItemModifierOptionGroup: {
      type: Object,
      required: false,
    },
    itemByGroupOrSubGroupData: {
      type: Object,
      required: false,
    },
    itemObject: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      keyReloadModalAddExistingItem: "keyReloadModalAddExistingItem",
    };
  },
  methods: {
    openSelectExistingItem() {
      $("#hide-modal-select-item").click();
      this.keyReloadModalAddExistingItem = Math.random();
      $("#show-modal-add-existing-item").click();
      // if (this.type == 1) { // Main
      //   this.keyReloadModalAddExistingItem = Math.random();
      //   $("#show-modal-add-existing-item").click();
      // } else {
      //   this.keyReloadModalSelectItem = Math.random();
      //   $(".btn-select-item-modal").click();
      // }
    },

    openModalCreateItem() {
      $("#hide-modal-select-item").click();
      this.$emit("create-new-item", this.categoryId);
    },

    openModalCreateCombo() {
      $("#hide-modal-select-item").click();
      this.$emit("create-new-combo");
    },

    reloadListCategory(mess) {
      this.$emit("reload-list-category", mess);
    },

    reloadListAttachedToItem(mess) {
      this.$emit("reload-list-attached-to-item", mess);
    },

    addPreiewItemSelected(data) {
      this.$emit("add-preiew-item-selected", data);
    },
  },
};
</script>

<style scoped>
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}
.content {
  cursor: pointer;
  text-align: center;
  width: 250px;
  height: 250px;
  margin-top: 25px;
  border: 1px solid #ccc;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.css-icon {
  font-size: 50px !important;
}
.css-icon-menubook {
  position: relative;
  font-size: 50px !important;
}
.font-18 {
  font-size: 18px;
}
.mt-content {
  margin-top: 5rem;
}
@media (max-width: 500px) {
  .row {
    width: unset !important;
  }
  .content {
    width: 200px;
    height: 200px;
  }
}
</style>
